import type { SchemaField, WalkFieldsOptions } from '@cli-types/core-engine/schema.js'
import { walkFields } from './walk-fields.js'

export function someField(
  fields: SchemaField[],
  predicate: (field: SchemaField) => boolean,
  options?: WalkFieldsOptions
): boolean {
  let found = false
  walkFields(
    fields,
    (field) => {
      if (predicate(field)) {
        found = true
        return true
      }
    },
    options
  )
  return found
}
